/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Delete_WordsInputs */

const en_us2_search_field_delete_words = /** @type {(inputs: Search_Field_Delete_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`delete remove erase account cancel`)
};

const pt_br2_search_field_delete_words = /** @type {(inputs: Search_Field_Delete_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`excluir apagar deletar conta cancelar`)
};

const es_419_search_field_delete_words = /** @type {(inputs: Search_Field_Delete_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eliminar borrar quitar cuenta cancelar`)
};

const pt_pt2_search_field_delete_words = /** @type {(inputs: Search_Field_Delete_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eliminar apagar excluir conta cancelar`)
};

const fr_fr2_search_field_delete_words = /** @type {(inputs: Search_Field_Delete_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`supprimer effacer compte resilier`)
};

const de_de2_search_field_delete_words = /** @type {(inputs: Search_Field_Delete_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`löschen entfernen konto kündigen`)
};

const it_it2_search_field_delete_words = /** @type {(inputs: Search_Field_Delete_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`elimina cancella rimuovi account chiudi`)
};

/**
* | output |
* | --- |
* | "delete remove erase account cancel" |
*
* @param {Search_Field_Delete_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_delete_words = /** @type {((inputs?: Search_Field_Delete_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Delete_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_delete_words(inputs)
	if (locale === "es-419") return es_419_search_field_delete_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_delete_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_delete_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_delete_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_delete_words(inputs)
	return en_us2_search_field_delete_words(inputs)
});
export { search_field_delete_words as "search.field_delete_words" }